"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product = void 0;
const GetProductDetails_1 = require("./GetProductDetails");
const GetProductList_1 = require("./GetProductList");
const GetProductSizeDetails_1 = require("./GetProductSizeDetails");
const PostProductAdd_1 = require("./PostProductAdd");
const PostProductDelete_1 = require("./PostProductDelete");
const PostProductEdit_1 = require("./PostProductEdit");
const PostProductRemove_1 = require("./PostProductRemove");
const PostProductSizeAdd_1 = require("./PostProductSizeAdd");
const PostProductSizeDelete_1 = require("./PostProductSizeDelete");
const PostProductSizeEdit_1 = require("./PostProductSizeEdit");
__exportStar(require("./GetProductDetails"), exports);
__exportStar(require("./GetProductList"), exports);
__exportStar(require("./GetProductSizeDetails"), exports);
__exportStar(require("./PostProductAdd"), exports);
__exportStar(require("./PostProductDelete"), exports);
__exportStar(require("./PostProductEdit"), exports);
__exportStar(require("./PostProductRemove"), exports);
__exportStar(require("./PostProductSizeAdd"), exports);
__exportStar(require("./PostProductSizeDelete"), exports);
__exportStar(require("./PostProductSizeEdit"), exports);
exports.Product = {
    GetProductDetails: GetProductDetails_1.GetProductDetails,
    GetProductList: GetProductList_1.GetProductList,
    GetProductSizeDetails: GetProductSizeDetails_1.GetProductSizeDetails,
    PostProductAdd: PostProductAdd_1.PostProductAdd,
    PostProductDelete: PostProductDelete_1.PostProductDelete,
    PostProductEdit: PostProductEdit_1.PostProductEdit,
    PostProductRemove: PostProductRemove_1.PostProductRemove,
    PostProductSizeAdd: PostProductSizeAdd_1.PostProductSizeAdd,
    PostProductSizeDelete: PostProductSizeDelete_1.PostProductSizeDelete,
    PostProductSizeEdit: PostProductSizeEdit_1.PostProductSizeEdit
};
//# sourceMappingURL=index.js.map